import { addDays, format } from "date-fns";
import type { ScheduleEntryInput, StaffScheduleEntry } from "@bednbody/types";

export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;

export function currentManilaWeekStart(now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Manila",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((candidate) => candidate.type === type)?.value ?? "";
  const date = new Date(`${part("year")}-${part("month")}-${part("day")}T00:00:00.000Z`);
  const daysSinceMonday = (date.getUTCDay() + 6) % 7;
  date.setUTCDate(date.getUTCDate() - daysSinceMonday);
  return date.toISOString().slice(0, 10);
}

export function weekDates(weekStart: string): string[] {
  const start = new Date(`${weekStart}T00:00:00.000Z`);
  return Array.from({ length: 7 }, (_, index) => addDays(start, index).toISOString().slice(0, 10));
}

export function shiftWeek(weekStart: string, amount: number): string {
  return addDays(new Date(`${weekStart}T00:00:00.000Z`), amount * 7)
    .toISOString()
    .slice(0, 10);
}

export function formatWeekRange(weekStart: string): string {
  const dates = weekDates(weekStart);
  return `${format(new Date(`${dates[0]}T00:00:00.000Z`), "MMM d")}–${format(
    new Date(`${dates[6]}T00:00:00.000Z`),
    "MMM d, yyyy",
  )}`;
}

export function timeInManila(value: string | null): string {
  if (!value) return "";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Manila",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(value));
}

export function dutyInput(
  scheduleDate: string,
  startTime: string,
  endTime: string,
  availabilityNote?: string,
): ScheduleEntryInput {
  const dutyStart = new Date(`${scheduleDate}T${startTime}:00+08:00`);
  const dutyEnd = new Date(`${scheduleDate}T${endTime}:00+08:00`);
  if (dutyEnd <= dutyStart) dutyEnd.setUTCDate(dutyEnd.getUTCDate() + 1);
  return {
    kind: "duty",
    scheduleDate,
    dutyStart: dutyStart.toISOString(),
    dutyEnd: dutyEnd.toISOString(),
    ...(availabilityNote?.trim() ? { availabilityNote: availabilityNote.trim() } : {}),
  };
}

export function entryFor(
  entries: StaffScheduleEntry[],
  staffId: string,
  scheduleDate: string,
): StaffScheduleEntry | undefined {
  return entries.find((entry) => entry.staffId === staffId && entry.scheduleDate === scheduleDate);
}
